export function mapIdTitleToValueName (items) {
  if (!Array.isArray(items)) return []

  return items.map(item => ({
    value: item.id,
    name: item?.title || item?.name
  }))
}

export function mapIdAndPromtToValueQuestions (items) {
  if (!Array.isArray(items)) return []

  return items.map(item => ({
    value: item.id,
    name: item?.prompt || item?.title
  }))
}
